// Only the Bootstrap component that needs its JS: Collapse (mobile navbar
// toggle, areas accordion). Importing it registers its data-bs-toggle handlers.
// The nav dropdowns are plain TS below, so Dropdown and Popper stay out of the bundle
import 'bootstrap/js/src/collapse.js';

const desktop = window.matchMedia('(min-width: 768px)');

document.querySelectorAll<HTMLElement>('.nav-item.dropdown').forEach((item) => {
   const toggle = item.querySelector<HTMLAnchorElement>('.dropdown-toggle');
   const menu = item.querySelector<HTMLElement>('.dropdown-menu');
   if (!toggle || !menu) return;

   const set = (open: boolean) => {
      menu.classList.toggle('show', open);
      toggle.classList.toggle('show', open);
      toggle.setAttribute('aria-expanded', String(open));
   };

   // Desktop: menus open on hover and a click follows the top-level link.
   // Mobile: a tap toggles the submenu inside the open navbar
   toggle.addEventListener('click', (e) => {
      if (desktop.matches) return;
      e.preventDefault();
      set(!menu.classList.contains('show'));
   });
   item.addEventListener('mouseenter', () => desktop.matches && set(true));
   item.addEventListener('mouseleave', () => desktop.matches && set(false));
   // Keyboard: open while focus is inside, Escape closes
   item.addEventListener('focusin', () => desktop.matches && set(true));
   item.addEventListener('focusout', (e) => {
      if (desktop.matches && !item.contains(e.relatedTarget as Node | null)) set(false);
   });
   item.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      set(false);
      toggle.focus();
   });
});

